import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit, Inject } from '@angular/core';
import { json } from './getstarted-object';
import { DOCUMENT } from '@angular/common';
import { EventsService, SignupService, StorageService, UtilService, VariablesService } from 'src/app/shared/services';
import { CommonTalktousModalComponent } from 'src/app/common/common-talktous-modal/components/common-talktous-modal/common-talktous-modal.component';

@Component({
  selector: 'app-howtogetstarted',
  templateUrl: './howtogetstarted.component.html',
  styleUrls: ['./howtogetstarted.component.scss']
})
export class HowtogetstartedComponent implements OnInit {
  getdescriptions: any[] = json;

  constructor(
    public dialog: MatDialog,
    public utilService: UtilService,
    public eventService: EventsService,
    private signupService: SignupService,
    private storageService: StorageService,
    @Inject(DOCUMENT) private document: any,
    private variablesService: VariablesService
  ) { }

  ngOnInit() {
  }

  openDialogTalkToUs() {
    this.dialog.open(CommonTalktousModalComponent, {
      maxWidth: '100vw',
      width: '519px',
      maxHeight: this.utilService.isMobile() ? '100vh' : 'auto',
      panelClass: 'talk-to-us-modal'

    });
  }
  /*Event for start a fundraiser body button */
  pushBodyButton(url) {
    const payload = {
      eventName: 'start_a_campaign_initiated',
      event_type: 'campaign',
      page_name: this.variablesService.pageName || 'home',
      referrer_page: this.document.referrer,
      info_1: 'type',
      info_2: 'home_3'
    };
    const full_url = `${this.utilService.domain_details.domain_url}/${url}`;
    this.eventService.sendSystemEvent(payload).subscribe(() => {
      // this.utilService.nativeNavigation(full_url);
    });
    this.storageService.checkFromSession('sac-initiated', payload);
    this.variablesService.loginType = 'signup';
    this.signupService.startFR(full_url);
  }

}
